BX.Vue.component('aos__processing',
    {
        computed: {
        },
        data: function () {
            return {
                email: null,
            };
        },
        methods: {
            msg: function (code) {
                return BX.aBase.msg(code);
            },
        },
        mounted: function () {
            let vm = this;
            vm.$parent.title = vm.msg('A_AOS_PROCESSING_TITLE');
            vm.$parent.titleClass = 'ocf__info__title';
            if (vm.$parent.clientData.email) {
                vm.email = vm.$parent.clientData.email;
            }
            vm.$parent.removeMessageError();
            vm.$parent.scrollToElement('._aos', 0);
        },
        template: `
          <div class="aos__processing">
          <div class="ocf__block ocf__info-wrap">
            <div class="ocf__info">
              <div class="ocf__info-block">
                <div class="ocf__info-title" v-html="msg('A_AOS_PROCESSING_TIT')"></div>
                <div class="ocf__info-desc" v-html="msg('A_AOS_PROCESSING_DESC')"></div>
                <div class="ocf__info-phone" v-html="msg('A_AOS_PROCESSING_PHONE')"></div>
              </div>
            </div>
            <div class="ocf__info" v-if="email">
              <div class="ocf__info-block">
                <div class="ocf__info-desc">
                  {{ msg('A_AOS_PROCESSING_U_EMAIL') }}
                  <div class="ocf__info-email" v-html="email"></div>
                </div>
              </div>
            </div>
          </div>
          </div>
        `,
    }
);